import { PathsEnum } from '@routes/enumerators/paths.enum';

export const pages = [
	{ name: 'Início', path: PathsEnum.COLABORADOR, disabled: false, visible: true },
	{ name: 'Demonstrativo de pagamentos', path: PathsEnum.HOLERITE, disabled: false, visible: true },
	{ name: 'Banco de horas', path: PathsEnum.BANCODEHORAS, disabled: false, visible: true },
	{ name: 'Informe de rendimentos', path: PathsEnum.INFORMERENDIMENTOS, disabled: false, visible: true },
	{ name: 'Férias', path: PathsEnum.FERIAS, disabled: false, visible: true },
	{ name: 'Detalhes do período', path: PathsEnum.DETALHESPERIODO, disabled: false, visible: true },
	{ name: 'Detalhes das férias', path: PathsEnum.DETALHESFERIAS, disabled: false, visible: true },
	{ name: 'Benefícios', path: PathsEnum.BENEFICIOS, disabled: false, visible: true },
	{ name: 'Vale Alimentação/Refeição', path: PathsEnum.ALIMENTACAO, disabled: false, visible: true },
	{ name: 'Vale Transporte', path: PathsEnum.TRANSPORTE, disabled: false, visible: true },
	{ name: 'Plano de saúde (UNIMED)', path: PathsEnum.SAUDE, disabled: false, visible: true },
	{ name: 'Performance de Produto', path: PathsEnum.PERFORMANCE_PRODUTO, disabled: false, visible: true },
	{ name: 'Busca por Imagem', path: PathsEnum.VAREJO_PRODUTO_IMAGEM, disabled: false, visible: true }
];
